import { StreamData } from 'types/streamData'
import { Metadata } from '../adaptor/metadata'
import { FieldResolver } from './fieldResolver'
import { resolveDisplayTextRelatedFields } from './displayText/displayTextUtil'
import displayTextRangeResolver from './displayText'

const streamDataFieldResolvers: FieldResolver[] = [displayTextRangeResolver]

export const displayTextRelatedFieldsResolver: FieldResolver = (metadata: Metadata) => {
  let result = resolveDisplayTextRelatedFields((artifact: StreamData) => artifact, metadata)
  streamDataFieldResolvers.forEach((resolver) => {
    result = { ...result, ...resolver(metadata) }
  })

  if (metadata.isDeleted()) {
    delete result.isDisplayTextRtl
    result = { ...result, replyToAuthors: [] as string[] }
  }

  return result
}

export default displayTextRelatedFieldsResolver
